var babydan = babydan || {};
(function () {
    'use strict';
    babydan.init       = function () {
        babydan.navigation.init();
        babydan.socials.init();
        babydan.ecom.init();
        babydan.cc.init();
    };
    babydan.validation = {
        init: function() {
            jQuery.validator.addMethod("stepMismatch", function (val, el) {
                var jInput = jQuery(el);
                var multiplum = parseInt(jInput.data('multiplum'));
                var step = parseInt(el.step);
                var value = parseInt(val);

                if (multiplum < 2) {
                    return true;
                }

                if (multiplum > 1 && step !== multiplum) {
                    if (value > multiplum) {
                        step = multiplum;
                    }
                }

                return value % step === 0;
            }, "msgMultiplum");
            jQuery.validator.addMethod("belowMinimum", function (val, el) {
                var value = parseInt(val);
                var min = parseInt(el.min);
                return value >= min;
            }, "msgMin");
            jQuery.validator.addMethod("overMax", function (val, el) {
                var value = parseInt(val);
                var stock = parseInt(el.max);
                return value <= stock
            }, "msgMax");
        }
    };
    babydan.navigation = {
        init: function () {
            babydan.navigation.createSeeAllLink();
            babydan.navigation.inlineSearch();
        },
        createSeeAllLink: function () {
            jQuery('.js-last-of-navigation-group').each(function (index, element) {
                var lastMenuItemClone = jQuery(element).clone(),
                    megamenuNavItem   = jQuery(element).closest('.e-megamenu-nav'),
                    mainMenuItem      = jQuery(element).closest('.e-megamenu-item').find('.js-see-all-link'),
                    seeAllText        = jQuery('.js-e-nav-global').data('seeAllText');
                if (megamenuNavItem.is('.last-is-true') === false) {
                    lastMenuItemClone.find('.nav-link').attr('href', mainMenuItem.attr('href'));
                    lastMenuItemClone.find('.e-nav-pagename').text(seeAllText);
                    jQuery(element).after(lastMenuItemClone);
                }
            });
        },
        inlineSearch: function () {
            jQuery('.js-e-header').find('.js-babydan-inline-search-form').on('submit', function (event) {
                event.preventDefault();
                var strQuery = jQuery(event.target).find('.js-e-search-input').val();
                if (e4.util.hash.get('search') === undefined) {
                    e4.util.hash.set('search');
                    jQuery('.js-e-search-modal').find('.js-e-search-input').val(strQuery);
                }
            });
            jQuery('.js-e-search-modal').on('hide.bs.modal', function () {
                e4.util.hash.remove('search');
            });
        }
    };
    babydan.socials    = {
        init: function () {
            babydan.socials.activeCampaign.init();
            babydan.socials.instagram.init();
        },
        activeCampaign: {
            init: function () {
                var jElementWrapper = jQuery('.js-custom-active-campaign-wrapper');
                if (jElementWrapper.length > 0) {
                    jQuery('.js-custom-active-campaign-wrapper style').remove();
                    jQuery('.js-custom-active-campaign-wrapper').addClass('active-campaign-form');
                    jElementWrapper.find('._submit').addClass('btn btn-primary');
                    jElementWrapper.find('._form-branding').addClass('d-none');
                }
            }
        },
        instagram: {
            init: function () {
                var domElmInstagram = document.getElementById('instafeed');
                if (domElmInstagram !== null) {
                    jQuery.getScript('/Files/Templates/Designs/babydan/_assets/js/vendor/instafeed.js', function () {
                        babydan.socials.instagram.build(domElmInstagram);
                    });
                }
            },
            getTemplate: function () {
                var domStrCaptions = '<div class="instagram-feed-item-caption"><p>{{caption}}</p></div>',
                    domStrItem     = '<a class="instagram-feed-item" href="{{link}}" target="_blank" style="background-image:url({{image}})"><img src="/Files/Templates/Designs/babydan/_assets/img/trans.png" alt="{{caption}}">' + domStrCaptions + '</a>';
                return domStrItem;
            },
            build: function (domElmInstagram) {
                var feed = new Instafeed({
                    accessToken: domElmInstagram.dataset.token,
                    limit: parseInt(domElmInstagram.dataset.limit),
                    target: 'instagram-feed',
                    debug: false,
                    filter: null,
                    sort: null,
                    transform: null,
                    after: function () {
                        domElmInstagram.removeAttribute('data-token');
                        var feedItems = domElmInstagram.querySelectorAll('.instagram-feed-item');
                        for (var i = 0; i < feedItems.length; i++) {
                            feedItems[i].classList.add('instagram-feed-item-' + i);
                        }
                    },
                    template: babydan.socials.instagram.getTemplate()
                });
                feed.run();
            }
        }
    };
    babydan.ecom       = {
        init: function () {
            babydan.ecom.bindEvents();
        },
        bindEvents: function () { 
            jQuery(document).on('input blur', '.js-e-product-quantity', function (event) {
                jQuery(event.target).valid();
            });
            jQuery(document).on('input blur', '.js-e-orderline-quantity-input', function (event) {
                jQuery(event.target).valid();
            });
        }
    };
    babydan.cc         = {
        init: function () {
            var jForm = jQuery('.js-babydan-order-form');
            if (jForm.length === 1) {
                jQuery.when.apply(jQuery, [
                    e4.util.require.js(e4.settings.require.datepicker),
                    e4.util.require.js(e4.settings.require.handlebars)
                ]).then(function () {
                    e4.handlebars.registerHelpers('compare formatDate formatPrice');
                    e4.handlebars.registerTemplates('#js-e-handlebars-tmpl-orders-history');
                    babydan.cc.datepicker();
                    babydan.cc.xhr(jForm.get(0));
                });

            }
            babydan.cc.bindEvents();
        },
        bindEvents: function () {
            jQuery('.js-babydan-order-form').on('submit', function (event) {
                event.preventDefault();
                babydan.cc.xhr(event.target);
            }).on('reset', function (event) {
                setTimeout(function () {
                    babydan.cc.xhr(event.target);
                }, 1);
            }).on('keydown', function (event) {
                if (event.keyCode === 13) { // Enter
                    babydan.cc.xhr(event.target);
                }
            });
        },
        datepicker: function () {
            jQuery('.js-datepicker-input').each(function (index, domInput) {
                jQuery(domInput).datepicker({
                    format: 'yyyy-mm-dd'
                });
            });

        },
        xhr: function (domForm) {
            jQuery.ajax({
                url: domForm.action,
                data: jQuery(domForm).serialize()
            }).done(function (jsonData) {
                babydan.cc.build(jsonData);
            });
        },
        build: function (jsonData) {
            jQuery('.js-babydan-orders-hbs-container').html(e4.handlebars.tmpl.ordersHistory(jsonData));
        }
    };
}());
